"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotTag = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotTag = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Property_1=on,_Property_2=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "m34.315 22.35.778.777.002-.002-.78-.775ZM22.365 34.3l-.777-.778.777.778Zm-4.716 0 .778-.778-.778.778ZM3.332 20h-1.1c0 .292.116.572.323.778L3.332 20Zm0-16.667v-1.1a1.1 1.1 0 0 0-1.1 1.1h1.1Zm16.667 0 .777-.778A1.1 1.1 0 0 0 20 2.233v1.1ZM34.315 17.65l.78-.776-.002-.002-.778.778Zm-.777 3.922-11.95 11.95 1.555 1.556 11.95-11.95-1.556-1.556Zm-11.95 11.95a2.234 2.234 0 0 1-.726.485l.843 2.032a4.433 4.433 0 0 0 1.439-.962l-1.557-1.555Zm-.726.485c-.27.112-.561.17-.855.17v2.2c.583 0 1.16-.114 1.698-.338l-.843-2.032Zm-.855.17c-.294 0-.584-.058-.855-.17l-.843 2.032a4.433 4.433 0 0 0 1.698.338v-2.2Zm-.855-.17a2.236 2.236 0 0 1-.725-.485l-1.557 1.555c.412.412.901.74 1.44.962l.842-2.032Zm-.726-.486L4.11 19.221l-1.554 1.557 14.316 14.3 1.555-1.557ZM4.432 20V3.333h-2.2V20h2.2Zm-1.1-15.567h16.667v-2.2H3.332v2.2Zm15.889-.322 14.317 14.316 1.555-1.555L20.776 2.555l-1.555 1.556Zm14.314 14.314c.416.419.65.985.65 1.575h2.2a4.433 4.433 0 0 0-1.29-3.126l-1.56 1.551Zm.65 1.575c0 .59-.234 1.156-.65 1.574l1.56 1.551A4.434 4.434 0 0 0 36.386 20h-2.2Zm-22.286-8.5a.4.4 0 0 1-.4.4v2.2a2.6 2.6 0 0 0 2.6-2.6h-2.2Zm-.4.4a.4.4 0 0 1-.4-.4H8.9a2.6 2.6 0 0 0 2.6 2.6v-2.2Zm-.4-.4a.4.4 0 0 1 .4-.4V8.9a2.6 2.6 0 0 0-2.6 2.6h2.2Zm.4-.4a.4.4 0 0 1 .4.4h2.2a2.6 2.6 0 0 0-2.6-2.6v2.2Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Property_1=on,_Property_2=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotTag = SpotTag;
SpotTag.displayName = "SpotTag";